import DoctorList from "./components/doctorList";
import Footer from "./footer";
import Navbar from "./header";

export default function Doctors(){


    return(

        <>
        <Navbar  menuColor="red"/>

          <section  >

            <DoctorList/>
               
          </section>
        <Footer/>
        
        </>
    );
}